exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  box-sizing: border -box; }\n\nbody {\n  font-family: Arial, Helvetica, sans-serif; }\n\ntable {\n  border: 1px solid #ddd;\n  border-collapse: collapse;\n  width: 100%;\n  text-align: left;\n  font-family: Arial, Helvetica, sans-serif; }\n\nth, td {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 14px;\n  vertical-align: top;\n  height: 28px; }\n\n.cols {\n  width: 50%;\n  float: left; }\n\n.cols p {\n  margin: 0 0 5px 0;\n  font-size: 10px;\n  color: #7c7c7c; }\n\n.bg {\n  background: #e6dfec;\n  font-weight: bold; }\n\n.Noborder {\n  border: 0; }\n\n.myContainer {\n  width: 850px;\n  margin: 0 auto; }\n\n.head {\n  padding: 10px 8px;\n  width: 100%;\n  display: table; }\n\n.clear {\n  clear: both; }\n\n.title {\n  text-align: center;\n  margin: 40px 0 10px 0;\n  color: #623089;\n  text-decoration: underline; }\n\n.text-right {\n  text-align: right; }\n\nhr {\n  border-color: #623089;\n  border-width: 0;\n  background: #f7951d;\n  height: 1px; }\n\n.capitalize {\n  text-transform: capitalize; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/payroll/salary/salary.component.scss
// module id = ../../../../../src/app/hrms/payroll/salary/salary.component.scss
// module chunks = main